
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.footer-menu-section {font-family: var(--bh-ff-body)
}@media (min-width: 640px) {.footer-menu-section {display: grid
    }.footer-menu-section {flex-grow: 1
    }.footer-menu-section {grid-template-columns: repeat(3, minmax(0, 1fr))
    }
}@media (min-width: 1280px) {.footer-menu-section {max-width: 42rem
    }
}@media (min-width: 2180px) {.footer-menu-section {max-width: 48rem
    }
}.footer-menu-section > ghs-footer-slotted-block-menu {padding-top: 2rem
}@media (min-width: 640px) {.footer-menu-section > ghs-footer-slotted-block-menu {padding-right: 2rem
    }
}@media (min-width: 640px) {.footer-menu-section > ghs-footer-slotted-block-menu {padding-top: 0px
    }
}@media (min-width: 640px) {.footer-menu-section > ghs-footer-slotted-block-menu {padding-left: 2rem
    }
}.footer-menu-section > ghs-footer-slotted-block-menu + ghs-footer-slotted-block-menu {border-width: 0px
}.footer-menu-section > ghs-footer-slotted-block-menu + ghs-footer-slotted-block-menu {border-top-width: 1px
}.footer-menu-section > ghs-footer-slotted-block-menu + ghs-footer-slotted-block-menu {border-style: solid
}.footer-menu-section > ghs-footer-slotted-block-menu + ghs-footer-slotted-block-menu {border-color: var(--bh-brand-primary-light)
}@media (min-width: 640px) {.footer-menu-section > ghs-footer-slotted-block-menu + ghs-footer-slotted-block-menu {border-left-width: 1px
    }
}@media (min-width: 640px) {.footer-menu-section > ghs-footer-slotted-block-menu + ghs-footer-slotted-block-menu {border-top-width: 0px
    }
}@media (min-width: 640px) {.footer-menu-section > ghs-footer-slotted-block-menu:last-of-type {padding-right: 0px
    }
}

@media (min-width: 640px) {:host([microsite='bhLogoFitness']) .footer-menu-section {grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1280px) {:host([microsite='bhLogoFitness']) .footer-menu-section {max-width: 36rem
    }
}

@media (min-width: 2180px) {:host([microsite='bhLogoFitness']) .footer-menu-section {max-width: 42rem
    }
}
`;